import { Container, Row as RowFix, Col } from "styled-bootstrap-grid"
import styled from "styled-components"

const Row = styled(RowFix)`
  /* Fix for IE11 */
  width: ${({ theme }) =>
    `calc(100% + ${theme.styledBootstrapGrid.row.padding * 2}px)`};
`

export { Container, Row, Col }
